export default __webpack_public_path__ + "static/media/confeti de fondo.94dc90fb.png";